import { Grid, Typography } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../../../hooks/CompanyConfiguration/useRegion'
import CustomInput from '../../../CustomInput'
import CustomSelect from '../../../CustomSelect'
import CustomSwitch from '../../../CustomSwitch'
import SwitchStatus from '../../../SwitchStatus'

function EditZoneComp({ state, setState }) {
  const { name, region, zoneCode, active } = state
  const { getAllRegion } = useRegion()
  const { regions } = useContext(ConfigurationContext)

  useEffect(() => getAllRegion(), [])
  const data = [
    { label: 'Zone Code', value: zoneCode, name: 'zoneCode' },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Region', value: region, name: 'region', select: true, options: regions },
  ]

  return (
    <Grid container>
      {data.map((item, index) =>
        item.select ? (
          <Grid item lg={4} key={item.label}>
            <CustomSelect
              label={item.label}
              button={item.button}
              options={item.options}
              value={item.value}
              // handleChange={item.handleChange}
              form={state}
              setForm={setState}
              formCheck={true}
              name={item.name}
              disabled={item.disabled}
              shrink={true}
            />
          </Grid>
        ) : (
          <Grid item lg={4}>
            <CustomInput
              label={item.label}
              icon={item.icon}
              name={item.name}
              value={item.value}
              number={item.number ? true : false}
              //   form={targetForm}
              //   setForm={setTargetForm}
              form={state}
              setForm={setState}
              formCheck={true}
              type={item.type}
            />
          </Grid>
        )
      )}

      <SwitchStatus form={state} setForm={setState} value={active} />
    </Grid>
  )
}

export default EditZoneComp
